(function () {
  'use strict';

  function qualifiesForShipping(price, currency, shopCurrency, rate) {
    if (!Number.isFinite(price) || price < 0) return false;
    if (currency === 'USD') return price >= 10000;
    if (shopCurrency !== 'USD' || !Number.isFinite(rate) || rate <= 0) return false;
    return price >= Math.ceil(10000 * rate - 0.0000001);
  }

  function compactStockText(text) {
    return text.replace(/In stock\s*[—–-]\s*ships in 24 hours\s*[.,·—–-]?\s*(Delivers?\s+in)/gi, 'In stock · Delivers in');
  }

  var configElement = document.getElementById('KensuiProductDetailsConfig');
  if (!configElement || window.ksuProductDetailsInitialized) return;
  window.ksuProductDetailsInitialized = true;
  var config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  var paymentSelector = '[class*="installment"],.pdp-inst,.ezv-inst,.sv2-inst,.smx-inst,.swi-inst,.t10-inst,.tor-inst,.cdb-inst,.lst-inst,.mbc-inst,.nb2-price__inst,.db-price__inst,.cbp-fin,.bbb-fin,.fin,.kgp-payment-terms,shopify-payment-terms,[data-ksu-payment-plan]';
  var variants = new Map((config.variants || []).map(function (variant) { return [String(variant.id), variant]; }));
  var benefits = new Map();
  var pending = false;

  function updateReviews() {
    document.querySelectorAll('.jdgm-prev-badge__text').forEach(function (label) {
      var current = label.textContent.trim();
      if (!/^[\d\s,.()]+$/.test(current)) return;
      var badge = label.closest('.jdgm-prev-badge');
      var count = badge && Number(badge.getAttribute('data-number-of-reviews'));
      if (!Number.isFinite(count) || count < 1) return;
      var format = count === 1 ? config.reviewOne : config.reviewMany;
      if (format) label.textContent = format.replace('__COUNT__', current.replace(/[()]/g, '').trim());
    });
  }

  function updateStock() {
    document.querySelectorAll('[class*="stock"],.stock').forEach(function (stock) {
      if (!/ships in 24 hours/i.test(stock.textContent)) return;
      var walker = document.createTreeWalker(stock, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script,style')) continue;
        var next = compactStockText(node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
    });
  }

  function variantFor(plan) {
    var root = plan.closest('section[data-product-handle],section[data-product-id],.kgp,[data-kb-product],section') || document.getElementById('MainContent');
    if (!root) return null;
    var handle = root.getAttribute('data-product-handle');
    if (handle && handle !== config.handle) return null;
    var inputs = Array.from(root.querySelectorAll('form[action*="/cart/add"] [name="id"], [data-payment-variant]'));
    var input = inputs.find(function (el) {
      return variants.has(String(el.value)) && el.closest('form').getClientRects().length;
    }) || inputs.find(function (el) { return variants.has(String(el.value)); });
    if (input) return variants.get(String(input.value));
    var selected = root.querySelector('[data-variant-id][aria-checked="true"],[data-variant-id][aria-pressed="true"],[data-variant-id].is-active');
    if (selected && variants.has(selected.getAttribute('data-variant-id'))) return variants.get(selected.getAttribute('data-variant-id'));
    return variants.get(String(config.initialVariant)) || null;
  }

  function updatePayments() {
    if (config.country === 'US') return;
    document.querySelectorAll('p > span').forEach(function (span) {
      if (/^pay in 4 interest-free payments with\s*$/i.test(span.textContent.trim()) && span.querySelector('img[alt="Shop Pay"]')) {
        if (!span.hasAttribute('data-ksu-payment-plan')) span.setAttribute('data-ksu-payment-plan', '');
      }
    });
    var currency = window.Shopify && window.Shopify.currency;
    var activeCurrency = currency && currency.active || config.currency;
    var rate = Number(currency && currency.rate);
    document.querySelectorAll(paymentSelector).forEach(function (plan) {
      if (plan.parentElement.closest(paymentSelector) || !plan.closest('main') || !config.handle) return;
      if (!benefits.has(plan)) {
        var benefit = document.createElement('span');
        benefit.className = 'ksu-shipping-benefit';
        benefit.textContent = config.freeShipping;
        benefit.title = config.freeShippingThreshold;
        benefit.hidden = true;
        plan.insertAdjacentElement('afterend', benefit);
        benefits.set(plan, benefit);
      }
      var variant = variantFor(plan);
      var eligible = !!variant && qualifiesForShipping(variant.price, activeCurrency, config.shopCurrency, rate);
      var label = benefits.get(plan);
      if (label.hidden === eligible) label.hidden = !eligible;
    });
  }

  function update() {
    pending = false;
    updateReviews();
    updateStock();
    updatePayments();
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }

  function start() {
    update();
    document.addEventListener('change', schedule);
    document.addEventListener('click', schedule);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('product:variant-change', schedule);
    document.addEventListener('shopify:section:load', schedule);
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        if (!target || target.closest('.ksu-shipping-benefit')) return false;
        if (target.closest('.jdgm-prev-badge,[class*="stock"],[class*="price"],[class*="installment"],[data-ksu-payment-plan]')) return true;
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('.jdgm-prev-badge,' + paymentSelector) || node.querySelector('.jdgm-prev-badge,' + paymentSelector));
        });
      });
      if (relevant) schedule();
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['value', 'aria-checked', 'aria-pressed', 'data-number-of-reviews'] });
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
